import PropTypes from 'prop-types';
import { createContext, useContext, useState } from 'react';
import { INSTALL_MODAL_STEPS } from '@constants';

export const InstallModalContext = createContext(null);

const InstallModalContextProvider = ({ children }) => {
	const isOpenState = useState(false);
	const currentStep = useState(INSTALL_MODAL_STEPS.INSTALL);

	return (
		<InstallModalContext.Provider value={{ isOpenState, currentStep }}>
			{children}
		</InstallModalContext.Provider>
	);
};

export const useInstallModalContext = () => {
	const { isOpenState, currentStep } = useContext(InstallModalContext);
	const [isOpen, setIsOpen] = isOpenState;
	const [step, setStep] = currentStep;

	const open = () => {
		setIsOpen(true);
	};

	const close = () => {
		setIsOpen(false);
		setStep(INSTALL_MODAL_STEPS.INSTALL);
	};

	const goToStep = (step) => {
		if (!Object.values(INSTALL_MODAL_STEPS).includes(step)) {
			return;
		}

		setStep(step);
	};

	return {
		isOpen,
		step,
		goToStep,
		open,
		close,
	};
};

InstallModalContextProvider.propTypes = {
	children: PropTypes.node,
};

export default InstallModalContextProvider;
